import { CALL_INIT, MEDIA_CHANGE, CALL_DURATION_CHANGE, CALL_END, CALL_STATUS_CHANGE, CALL_CONNECTED } from '../constants/ActionTypes';

function CallReducer(state = { type: '', status: '', phone: '', flowId: '', token: '', callId: '', apiUrl: ''}, { type: actionType, payload }) {
  if (actionType === CALL_INIT && state.status === '') {
    return {
      ...state,
      ...payload,
      status: 'start'
    }
  }
  if (actionType === MEDIA_CHANGE) {
    return {
      ...state,
      type: payload.type,
      status: payload.status
    }
  }
  if (actionType === CALL_STATUS_CHANGE) {
    return {
      ...state,
      status: payload.status
    }
  }
  if (actionType === CALL_DURATION_CHANGE) {
    return {
      ...state,
      duration: payload.duration
    }
  }
  if (actionType === CALL_END) {
    return {
      type: '', 
      status: '', 
      phone: '', 
      flowId: '',
      token: ''
    }
  }
  if (actionType === CALL_CONNECTED) {
    return {
      ...state,
      callId: payload.callId
    }
  }
  return state;
}

export default CallReducer;